import { FullWidthLayout } from "@/layouts";
import * as Styled from "./legalPolicies";

export const ManagamentPolicy = () => {
  return (
    <FullWidthLayout id="free-trial" bgColor="var(--background-light)" borderColor="var(--on-primary-dark)">
      <Styled.LegalContainer>
        <Styled.BoxContent>
          <h1 className="headline-large weight-medium">Management Policy</h1>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <p className="body-medium">
            Our vision guides the path followed by our organization. Therefore, we base our management policy on the following statements:
          </p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Regarding the security of information:</h2>
          <ul>
            <li>
              <p className="body-medium">
                We guarantee the <span className="body-medium weight-medium">confidentiality, integrity,</span> and{" "}
                <span className="body-medium weight-medium">availability</span> of information and services by ensuring that only authorized people can access
                the company&apos;s resources and sources. We achieve this by implementing access control policies, encryption, and secure data handling
                procedures.
              </p>
            </li>
            <li>
              <p className="body-medium">
                We conduct regular risk assessments to identify potential threats and vulnerabilities to our information and services. We prioritize risks and
                opportunities and implement measures to address them promptly.
              </p>
            </li>
            <li>
              <p className="body-medium">
                We meet SLAs and established requirements to ensure the availability of information and our services. We also have business continuity, and
                disaster recovery plans to minimize downtime in the event of disruptions.
              </p>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Regarding customer satisfaction:</h2>
          <ul>
            <li>
              <p className="body-medium">
                Cellect is fully committed to satisfying the needs of its customers. We actively listen to customer feedback and strive to exceed their
                expectations by delivering high-quality services and products.
              </p>
            </li>
            <li>
              <p className="body-medium">
                Cellect is fully committed to achieving the requirements of the services we provide. We regularly monitor and assess our performance to ensure
                we meet or exceed the agreed-upon service levels.
              </p>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">We ensure that all our processes comply with:</h2>
          <ul>
            <li>
              <p className="body-medium">
                Our customers’ information security requirements. We consider their security concerns and implement measures to protect their data and privacy.
              </p>
            </li>
            <li>
              <p className="body-medium">
                The legal information security requirements. We comply with relevant laws and regulations regarding information security, privacy, and
                protection.
              </p>
            </li>
            <li>
              <p className="body-medium">Regulatory information security requirements. We comply with industry-specific regulations.</p>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Regarding continuous improvement:</h2>
          <ul>
            <li>
              <p className="body-medium">We are committed to continuously improving our services, processes, and all security-related topics.</p>
            </li>
            <li>
              <p className="body-medium">
                We regularly review and assess our security policies and procedures and implement improvements based on industry best practices.
              </p>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Regarding the company&apos;s leadership:</h2>
          <ul>
            <li>
              <p className="body-medium">The top management is leading by example and is fully committed to the company&apos;s standards.</p>
            </li>
            <li>
              <p className="body-medium">We provide the necessary resources to implement and maintain our security policies and procedures.</p>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Regarding the participation of people:</h2>
          <ul>
            <li>
              <p className="body-medium">
                All Cellect&apos;s employees have autonomy and the opportunity to participate in the organization&apos;s daily operations actively.
              </p>
            </li>
            <li>
              <p className="body-medium">We encourage open communication, teamwork, and collaboration among our employees.</p>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Our approach is based on:</h2>
          <ul>
            <li>
              <p className="body-medium">
                Processes: We focus on customer orientation, continuous improvement, and internal communication to ensure that our processes are efficient and
                effective.
              </p>
            </li>
            <li>
              <p className="body-medium">
                From system to management: We ensure that our processes are interrelated and monitor and measure their performance to identify areas for
                improvement.
              </p>
            </li>
            <li>
              <p className="body-medium">
                Measurable facts for decision-making: We measure, analyze, and make decisions focused on improving the organization&apos;s performance and
                achieving our objectives.
              </p>
            </li>
            <li>
              <p className="body-medium">
                Mutually beneficial relationships with suppliers and partners that provide long-term relationships: We establish relationships with our
                suppliers and partners based on trust, transparency, and shared goals. We ensure that our relationships are mutually beneficial and contribute
                to the organization&apos;s success.
              </p>
            </li>
          </ul>
          <p style={{ display: "flex", alignSelf: "flex-end" }}>Approved by: Leon Gosh</p>
          <p style={{ display: "flex", alignSelf: "flex-end" }}>22.05.2023</p>
        </Styled.BoxContent>
      </Styled.LegalContainer>
    </FullWidthLayout>
  );
};
